import React, { ReactElement, useEffect } from 'react'

import jsBrowserHistory from '../components/widgets/jsBrowserHistory'
import LoadingOverlay from '../components/widgets/LoadingOverlay'
import paths from '../constants/paths'
import { CompanyReducer } from '../reducers/companies'
import { connectToReducer } from '../utils/reducer-utils'
import { url } from '../utils/request-utils'
import { RouteProps, splatString } from '../utils/route-utils'

type Reducers = {
  companies: CompanyReducer
}

function InTimeRegistration(props: Reducers & RouteProps): ReactElement | null {
  const { params, location, companies } = props
  useEffect(() => {
    const company = companies.company
    if (!company) {
      return
    }
    const values: Record<string, string | undefined> = { ...{ state: splatString(params.splat) }, ...location.query }
    if (location.hash) {
      const items = location.hash.substring(1).split('&')
      items.forEach((item) => {
        const [key, val] = item.split('=')
        values[key] = decodeURIComponent(val)
      })
    }
    jsBrowserHistory.push(
      url('/' + paths.COMPANIES + '/' + company.id + '/' + paths.DATA_PROVIDER + '/' + paths.ADD, values)
    )
  })

  return (
    <div style={{ position: 'relative', minHeight: '300px', marginTop: '96px' }}>
      <LoadingOverlay />
    </div>
  )
}

export default connectToReducer<Reducers, any, RouteProps>(
  (state) => ({
    companies: state.companies,
  }),
  {}
)(InTimeRegistration)
